import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { IChecklistReportSelectionComponent, IChecklistReportSelectionState } from '../../checklist-report';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-checklist-report-selection-dialog',
    template: `
        <fi-checklist-report-selection
            #checklistReportSelection
            [checklist]="data.checklist"
            [selections]="data.selections"
            [businessUnitsData]="data.businessUnitsData"
            [businessAreasData]="data.businessAreasData"
            [preselect]="data.currentSelection"
        >
        </fi-checklist-report-selection>
    `,
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./checklist-report-selection-dialog.component.scss'],
    standalone: false,
})
export class ChecklistReportSelectionDialogComponent extends FiDialogsContentBase<any, IChecklistReportSelectionState> {
    @ViewChild('checklistReportSelection', { static: false })
    checklistReportSelection: IChecklistReportSelectionComponent;

    getResult() {
        return {
            startDate: this.checklistReportSelection.StartDate,
            endDate: this.checklistReportSelection.EndDate,
            selectionsListDataModel: this.checklistReportSelection.selectionsListData.SelectedModel,
            businessUnitsListModel: this.checklistReportSelection.businessUnitsListData.SelectedModel.slice(),
            businessAreasListModel: this.checklistReportSelection.businessAreasListData.SelectedModel.slice(),
        };
    }
}
